import type { FC } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import PageTitle from "app/components/React/PageTitle/PageTitle";

import { useGetTrademarkById } from "../services/api/trademarks";

import { durationFilterConfigItem } from "./components/navbar-filters/filter-items/duration";
import { FiltersBar } from "./components/navbar-filters/FiltersBar";
import { TrademarkConfigDropdown } from "./components/trademark-selector/trademark-config-dropdown";
import { useMonitorAndProtectTrademarkDataAndParams } from "./hooks/trademark-params";
import { PageHeader } from "./ui/layout/page-header";

const TopLeftComponent = () => {
    return (
        <Flex
            paddingX="16px"
            gap="8px"
            alignItems="center"
        >
            <TrademarkConfigDropdown />
        </Flex>
    );
};

export const MonitorAndProtectTrademarkSubNav: FC = () => {
    const routeParams = useMonitorAndProtectTrademarkDataAndParams();
    const {
        showHeader: routeShowHeader,
        showFilters: routeShowFilters,
        showTrademarkSelector,
        trademarkId,
    } = routeParams;
    const { data, isError, isLoading } = useGetTrademarkById(trademarkId);
    const currentTrademarkLoaded = !isError && !!data && !isLoading;

    if (!routeShowHeader) {
        return null;
    }

    return (
        <PageHeader
            topLeftComponent={showTrademarkSelector ? <TopLeftComponent /> : null}
            bottomLeftComponent={currentTrademarkLoaded || !showTrademarkSelector ? <PageTitle /> : null}
            bottomRightComponent={
                currentTrademarkLoaded && routeShowFilters ? <FiltersBar filters={[durationFilterConfigItem]} /> : null
            }
        />
    );
};
